import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import CategorySelection from "./../CategorySelection/index.ts";
import CourseIndex from "./../CourseIndex/index.ts";
import Checkout from "../Checkout/index.ts";
import type { CategoryDto } from "../../shared/CategoryDto";
import { inject, onMounted, ref } from "vue";
import type { CategoryService } from "../../application/services/CategoryService.ts";
import { BFormInput } from "bootstrap-vue-next";

interface Props {
  categoryId: number;
}

export default {
  template: html,
  components: { CourseIndex, CategorySelection, Checkout, BFormInput},
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
  },
  setup(props:Props) {
    const view = ref("Category")
    const category = ref<CategoryDto|null>(null)
    const catgoryService = inject<CategoryService|undefined>("categoryService")
    const courseSearch = ref("")
    const courseId = ref(0)
    const onBookCourseId = async function(id: number){
      courseId.value = id 
      view.value = "Checkout"
    }
    const onCheckoutAbort = async function(){
      courseId.value = 0
      view.value = "Category"
    }
    const resetCourseSearch = function () {
      courseSearch.value = "";
    };

    onMounted(async () => {
      if (catgoryService){
        category.value = await catgoryService.getById(props.categoryId)
      }
    })
    return {
      category,
      courseId,
      onBookCourseId,
      onCheckoutAbort,
      resetCourseSearch,
      courseSearch,
      view
    };
  },
};
